import { tap } from 'rxjs/operators';
import { LayoutService } from './../layout.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { WebsiteService } from 'src/app/apps/website/website.service';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.less']
})
export class PagesComponent implements OnInit {
  isLoading = false;
  isPageCode = true;
  pageCode = '';
  content = '';
  constructor(
    private route: ActivatedRoute,
    private websiteService: WebsiteService
  ) { }

  ngOnInit() {
    this.pageCode = this.route.snapshot.data.pageCode;
    if (this.pageCode == null) {
      this.isPageCode = false;
    }
    else {
      this.getPage();
    }
  }

  getPage() {
    this.websiteService.getPageByCode(this.pageCode)
      .pipe(
        tap(page => {
          this.content = page.Content;
        })
      )
      .subscribe();
  }

}
